import React from "react";
import className from "classnames/bind";
import styles from "../OrderInfoPage.module.scss";
import useTranslations from "../../../hooks/useTranslations";

const cx = className.bind(styles);

const PaymentMethodSelector = ({ formData, handleInputChange }) => {
  const translations = useTranslations();

  return (
    <div className={cx("section")}>
      <h3>
        {translations?.Checkout?.select_payment_method ||
          "Select Payment Method"}
      </h3>
      <div className={cx("payment-methods")}>
        <label
          className={cx("payment-option" ,"payment-option--disabled", {
            active: formData.paymentMethod === "paypal",
          })}
        >
          <input
            type="radio"
            name="paymentMethod"
            value="paypal"
            disabled
            checked={formData.paymentMethod === "paypal"}
            onChange={handleInputChange}
          />
          <div className={cx("payment-content")}>
            <div className={cx("payment-icon")}>
              <img
                src="https://www.paypalobjects.com/webstatic/mktg/Logo/pp-logo-100px.png"
                alt="PayPal"
              />
            </div>
            <div className={cx("payment-info")}>
              <span className={cx("payment-name")}>
                {translations?.Checkout?.paypal || "PayPal"}
              </span>
              <span className={cx("payment-desc")}>
                {translations?.Checkout?.secure_payment ||
                  "Safe and secure payment"}
              </span>
            </div>
          </div>
        </label>

        <label
          className={cx("payment-option","payment-option--disabled", {
            active: formData.paymentMethod === "vnpay_visa",
          })}
        >
          <input
          
            type="radio"
            name="paymentMethod"
            value="vnpay_visa"
            checked={formData.paymentMethod === "vnpay_visa"}
            onChange={handleInputChange}
            disabled
          />
          <div className={cx("payment-content")}>
            <div className={cx("payment-icon")}>
              <img
                src="https://vnpay.vn/s1/statics.vnpay.vn/2023/9/06ncktiwd6dc1694418196384.png"
                alt="VNPay"
              />
            </div>
            <div className={cx("payment-info")}>
              <span className={cx("payment-name")}>
                {translations?.Checkout?.vnpay || "VNPay"}
              </span>
              <span className={cx("payment-desc")}>
                {translations?.Checkout?.vnpay_note ||
                  "Vietnamese payment gateway"}
              </span>
            </div>
          </div>
        </label>

        {/* COD - Hoạt động bình thường */}
        <label
          className={cx("payment-option", {
            active: formData.paymentMethod === "cod",
          })}
        >
          <input
            type="radio"
            name="paymentMethod"
            value="cod"
            checked={formData.paymentMethod === "cod"}
            onChange={handleInputChange}
          />
          <div className={cx("payment-content")}>
            <div className={cx("payment-icon")}>
              <div className={cx("cod-icon")}>💵</div>
            </div>
            <div className={cx("payment-info")}>
              <span className={cx("payment-name")}>
                {translations?.Checkout?.cod || "Cash on Delivery"}
              </span>
              <span className={cx("payment-desc")}>
                {translations?.Checkout?.cod_note || "Pay when you receive"}
              </span>
            </div>
          </div>
        </label>
      </div>
    </div>
  );
};

export default PaymentMethodSelector;
